/**
 * localStorage-backed session/preferences store for the saas-admin app.
 * Mirrors the pdvision-client Storage: a single flat JSON blob under one key.
 * No region logic — saas-admin talks to a single global core-api endpoint.
 */
export class Storage
{
    static STORAGE_ID = 'belturo-saas-admin-storage';

    // Note: This needs to be a flat data structure
    static DEFAULT_DATA = {
        "sessionToken" : null,
        // null = never chosen; the app then falls back to the browser's
        // language (see i18n/resolveLanguage).
        "language" : null
    };

    saveSessionToken( sessionToken )
    {
        this.save( "sessionToken", sessionToken );
    }

    loadSessionToken()
    {
        return this.load( "sessionToken" );
    }

    deleteSessionToken()
    {
        this.save( "sessionToken", null );
    }

    saveLanguage( langCode )
    {
        this.save( "language", langCode );
    }

    loadLanguage()
    {
        return this.load( "language" );
    }

    load( key, defVal = null )
    {
        const sd = this.loadStorageData();
        if ( sd.hasOwnProperty( key ) )
        {
            return sd[ key ];
        }
        else
        {
            return defVal;
        }
    }

    save( key, val )
    {
        const sd = this.loadStorageData();
        sd[ key ] = val;
        this.saveStorageData( sd );
    }

    saveStorageData( updatedSd )
    {
        localStorage.setItem( Storage.STORAGE_ID, JSON.stringify( updatedSd ) );
    }

    loadStorageData()
    {
        let sd = localStorage.getItem( Storage.STORAGE_ID );
        if ( sd && sd.length )
        {
            try
            {
                sd = JSON.parse( sd );
            }
            catch( e )
            {
                sd = {};
            }
        }
        return { ...Storage.DEFAULT_DATA, ...sd };
    }
}
